<template>
  <tbody class="loading-table-body">
    <tr
      v-for="row in rows"
      :key="row"
    >
      <td
        v-for="col in columns"
        :key="col"
      />
    </tr>
  </tbody>
</template>

<script>
export default {
  name: 'AppTableLoadingBody',
  props: {
    columns: {
      type: Number,
      default: 2,
    },
    rows: {
      type: Number,
      default: 4,
    },
  },
};
</script>
